import {useStickyObserver} from '@github-ui/use-sticky-header/useStickyObserver'
import {clsx} from 'clsx'

import {useStickyHeaderStyle} from '../../hooks/use-sticky-observer'
import FileNameStickyHeader from './FileNameStickyHeader'
import styles from './FolderViewHeader.module.css'

export default function FolderViewHeader({
  showTree,
  treeToggleElement,
}: {
  showTree: boolean
  treeToggleElement: React.ReactElement | null
}) {
  const {isSticky: isStickied, sentinelRef: headerRef} = useStickyObserver()
  const stickyStyle = useStickyHeaderStyle()
  return (
    <div
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className={clsx('react-blob-view-header-sticky', isStickied ? styles.outerWrapperStickied : styles.outerWrapper)}
      style={stickyStyle}
      ref={headerRef}
    >
      <div
        className={clsx(styles.innerWrapper, isStickied ? styles.innerWrapperStickied : styles.innerWrapperNotStickied)}
      >
        <FileNameStickyHeader isStickied={isStickied} showTree={showTree} treeToggleElement={treeToggleElement} />
      </div>
    </div>
  )
}
